module.exports = __webpack_public_path__ + "img/img57.6fd7476b.png";